//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

import _didNew_item_transaction_freightRunner from './didNew_item_transaction_freightRunner';
export const didNew_item_transaction_freightRunner = _didNew_item_transaction_freightRunner;
export default {didNew_item_transaction_freightRunner};

